// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5271) return "5271.f1ee3bcb437a9ad9031c.js";
	// return url for filenames based on template
	return "" + {"1167":"c884df8b18efa70f44d2","4800":"c2c51eaeb81cb3dc3f34"}[chunkId] + ".js";
};